import { useSelector } from 'react-redux';
import type { RootReduxState } from 'app/shared/flux/reducers/index';
import { container, section, sectionHeading, text } from './housemateDetailsModule.styles';

const ROOMMATES_HEADING_ID = 'housemate-details-roommates-heading';
const PETS_HEADING_ID = 'housemate-details-pets-heading';
const PREFERRED_HEADING_ID = 'housemate-details-preferred-heading';

export const HousemateDetailsModule = () => {
  const roomForRent = useSelector(
    (state: RootReduxState) => state.currentListingDetails?.currentListing?.details?.roomForRent,
  );

  const description = roomForRent?.roommateDetails?.description;
  const roommatesInfo = roomForRent?.roommateDetails?.roommatesInfo;
  const petsInfo = roomForRent?.roommateDetails?.petsInfo;
  const preferredNewRoommate = roomForRent?.preferredNewRoommate;

  if (!description && !roommatesInfo && !petsInfo && !preferredNewRoommate) {
    return null;
  }

  return (
    <div className={container}>
      {description && <p className={text}>{description}</p>}
      {roommatesInfo && (
        <section className={section} aria-labelledby={ROOMMATES_HEADING_ID}>
          <h3 className={sectionHeading} id={ROOMMATES_HEADING_ID}>
            Current housemates
          </h3>
          <p className={text}>{roommatesInfo}</p>
        </section>
      )}
      {petsInfo && (
        <section className={section} aria-labelledby={PETS_HEADING_ID}>
          <h3 className={sectionHeading} id={PETS_HEADING_ID}>
            Current pets
          </h3>
          <p className={text}>{petsInfo}</p>
        </section>
      )}
      {preferredNewRoommate && (
        <section className={section} aria-labelledby={PREFERRED_HEADING_ID}>
          <h3 className={sectionHeading} id={PREFERRED_HEADING_ID}>
            Preferred new housemate
          </h3>
          <p className={text}>{preferredNewRoommate}</p>
        </section>
      )}
    </div>
  );
};
